import { CsvExportFile } from '../graphql/export.graphql';
import { ExportFile } from '../types/export/export';
import { DownloadBlobPrompt } from './download.util';
import { toGroupedMap } from './map.util';
import JSZip from 'jszip';

type ExportConfigurations = Map<string, { name: string }>;

export async function zipAndDownloadExportFiles(
  files: CsvExportFile[],
  configurations: ExportConfigurations,
  zipName: string,
) {
  const filesByConfiguration = toGroupedMap(files, 'configurationId');

  const zip = new JSZip();
  for (const [configurationId, files] of filesByConfiguration) {
    const folder = zip.folder(configurations.get(configurationId)?.name || `ventory_reports`);

    for (let i = 0; i < files.length; i++) {
      const fileName = `${String(i + 1).padStart(3, '0')}_${files[i].fileName}`;
      folder?.file(fileName, files[i].content);
    }
  }

  const zipped = await zip.generateAsync({ type: 'blob' });
  DownloadBlobPrompt(zipped, zipName);
}

export namespace ExportUtil {
  export const downloadZip = async (
    files: ExportFile[],
    configurations: Map<string, { name: string }>,
    zipName: string = `ventory_reports_${new Date().toISOString()}.zip`,
  ) => {
    const filesByConfiguration = toGroupedMap(files, 'configurationId');

    const zip = new JSZip();
    for (const [configurationId, files] of filesByConfiguration) {
      const folder = zip.folder(configurations.get(configurationId)?.name || `ventory_reports`);

      for (let i = 0; i < files.length; i++) {
        const fileName = `${String(i + 1).padStart(3, '0')}_${files[i].name}`;

        const byteArray = new Uint8Array(files[i].buffer.data);
        const data = new Blob([byteArray], { type: files[i].mime });

        folder?.file(fileName, data);
      }
    }

    const zipped = await zip.generateAsync({ type: 'blob' });

    const url = window.URL.createObjectURL(zipped);
    const a = document.createElement('a');
    a.href = url;
    a.download = zipName;
    a.click();
  };

  export const downloadExport = (file: ExportFile) => {
    const byteArray = new Uint8Array(file.buffer.data);

    const url = window.URL.createObjectURL(new Blob([byteArray], { type: file.mime }));
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;
    a.click();
  };

  export const openInNewTab = (file: ExportFile) => {
    const byteArray = new Uint8Array(file.buffer.data);

    const url = window.URL.createObjectURL(new Blob([byteArray], { type: file.mime }));
    window.open(url, '_blank');
  };
}
